import { memo, useMemo } from 'react';
import useGlobalTransactionTimer, { getBackground, formatTime } from 'hooks/transaction/useGlobalTransactionTimer';
import PropTypes from 'prop-types';
import styles from './CameraStreamCompactHeader.module.css';

const TransactionDuration = ({ transactionStartTimestamp }) => {
    const { totalSeconds } = useGlobalTransactionTimer(transactionStartTimestamp);

    const style = useMemo(
        () => ({
            display: 'inline-flex',
            padding: '2px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            borderRadius: '2px',
            background: getBackground(totalSeconds),
        }),
        [totalSeconds]
    );

    const transactionDuration = useMemo(() => formatTime(totalSeconds), [totalSeconds]);

    return (
        <span className={styles['camera-stream-compact-header-assignee--duration']} style={style}>
            {transactionDuration}
        </span>
    );
};

TransactionDuration.propTypes = {
    transactionStartTimestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default memo(TransactionDuration);
